import { Property } from '@model';
import './SearchByPlaceBadge.scss';
import { useTranslation } from 'react-i18next';

type SearchByPlaceBadgeProps = {
  properties: Property[];
};

export const SearchByPlaceBadge = (props: SearchByPlaceBadgeProps) => {
  const { t } = useTranslation();

  return (
    <div className='search-by-place-badge'>
      <ul>
        <li>
          {props.properties.length}{' '}
          {t(
            props.properties.length > 1
              ? 'propertiesByArea.properties'
              : 'propertiesByArea.property',
          )}
        </li>
      </ul>
    </div>
  );
};
